export default __webpack_public_path__ + "static/media/3.3bf97b55.png";